import { render, staticRenderFns } from "./article_list.vue?vue&type=template&id=d5878918&scoped=true&"
import script from "./article_list.vue?vue&type=script&lang=js&"
export * from "./article_list.vue?vue&type=script&lang=js&"
import style0 from "./article_list.vue?vue&type=style&index=0&id=d5878918&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5878918",
  null
  
)

export default component.exports